import React from "react";
import { Link } from "react-router-dom";
import { AlertTriangle } from "lucide-react";

const NotFoundPage = () => {
	return (
		<div className='h-screen flex flex-col justify-center items-center bg-white text-red-700 p-4'>
			{/* Icon */}
			<AlertTriangle className='text-red-600 mb-4' size={56} />

			{/* Heading */}
			<h1 className='text-4xl font-extrabold mb-2 text-red-800'>
				404 - Page Not Found
			</h1>

			{/* Subtext */}
			<p className='mb-6 text-gray-600 text-center max-w-md'>
				Oops! The page you're looking for doesn’t exist or has been moved.
			</p>

			{/* Button */}
			<Link
				to='/dashboard'
				className='px-6 py-2 bg-red-600 text-white font-semibold rounded-lg shadow hover:bg-red-700 transition duration-300'
			>
				Go to Dashboard
			</Link>
		</div>
	);
};

export default NotFoundPage;
